<template>
  <div class="tool-list-about-card">
    <span
      @click="changeStyle('block')"
      :class="{ active: gridStyle === 'block' }"
    >
      <eva-icon fill="#000" name="grid-outline" />
    </span>
    <span @click="changeStyle('list')" :class="{ active: gridStyle === 'list' }">
      <eva-icon fill="#000" name="list-outline" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gridStyle: 'block'
    };
  },

  methods: {
    changeStyle(style) {
      this.gridStyle = style;
      this.$emit("changeStyle", style);
    },
  },
};
</script>
